import { ref } from "vue";
import { exceptionRequestMsg, showToast } from "@/assets/js/util";
import { cotizacionUnidadMargenService } from "@/services/cotizacion-unidad-margenes.service";
import { cotizacionUnidadMargenResidualService } from "@/services/cotizacion-unidad-margenes-residual.service";
import { cotizacionUnidadHistorialService } from "@/services/cotizacion-unidad.service";
import { useRoute, useRouter } from "vue-router";
import useUtil from "./useUtil";

export const useCotizacionUnidadMargen = () => {
  const listaMargenes = ref([]);
  const get = async () => {
    try {
      const res = await cotizacionUnidadMargenService.get();
      listaMargenes.value = res.data;
    } catch (error) {
      exceptionRequestMsg(error);
    }
  };
  return {
    get,
    listaMargenes,
  };
};

export const useCotizacionUnidadMargenResidual = () => {
  const listaMargenes = ref([]);
  const get = async () => {
    try {
      const res = await cotizacionUnidadMargenResidualService.get();
      listaMargenes.value = res.data;
    } catch (error) {
      exceptionRequestMsg(error);
    }
  };
  return {
    get,
    listaMargenes,
  };
};

export const useCotizacionUnidad = () => {
  const route = useRoute();
  const router = useRouter();
  const cotizacion = ref(undefined);
  const agente = ref(undefined);
  const cotizacionDetalle = ref([]);
  const token = ref(undefined);
  const { urlEndpoint } = useUtil();

  token.value = route.params.token;

  const getById = async () => {
    try {
      const res = await cotizacionUnidadHistorialService.getById(
        route.params.token
      );

      cotizacion.value = res.data.cotizacion;
      agente.value = res.data.agente;
      cotizacionDetalle.value = res.data.cotizacionDetalle;
    } catch (error) {
      console.error(error);
      exceptionRequestMsg(error);
    }
  };

  const copiarUrlAprobacion = async () => {
    navigator.clipboard
      .writeText(
        `${process.env.VUE_APP_URL}public/cotizacion/unidades/${token.value}`
      )
      .then(() => showToast("URL copiada al portapapeles", "info"))
      .catch((err) => console.error("Error al copiar:", err));
  };

  return {
    agente,
    copiarUrlAprobacion,
    cotizacion,
    cotizacionDetalle,
    getById,
    token,
    urlEndpoint,
  };
};

export const useCotizacionUnidadHistorial = () => {
  const listaCotizaciones = ref([]);
  const user = ref(undefined);
  const get = async () => {
    try {
      const res = await cotizacionUnidadHistorialService.get();
      listaCotizaciones.value = res.data.cotizacionUnidadHistorial;
      user.value = res.data.user;
    } catch (error) {
      exceptionRequestMsg(error);
    }
  };

  return {
    get,
    listaCotizaciones,
    user,
  };
};

export const useCotizacionUnidadEditar = () => {
  const cotizacion = ref(undefined);
  const cotizacionId = useRoute().params.token;
  const cotizacionDetalle = ref([]);
  const getCotizacion = async () => {
    try {
      const res = await cotizacionUnidadHistorialService.edit(cotizacionId);
      cotizacion.value = res.data.cotizacion;
      cotizacionDetalle.value = res.data.cotizacionDetalle;
    } catch (error) {
      exceptionRequestMsg(error);
    }
  };

  return {
    cotizacion,
    cotizacionDetalle,
    getCotizacion,
  };
};
